import Vue from 'vue'
import App from './App.vue'
import router from './router'
import httpRequest from 'axios' // api: https://github.com/axios/axios
import {isAuth, sec_to_time, time_to_sec} from '@/utils'
import {Excel} from "./utils/exportExcel"

Vue.filter('sec_to_time', sec_to_time);
Vue.filter('time_to_sec', time_to_sec);
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
// import '../static/css/theme-green/index.css';       // 浅绿色主题
import './assets/css/icon.css';
import './components/common/directives';
import "babel-polyfill";
import animated from 'animate.css'
import {getCookie} from "./utils/cookie";

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(animated);
httpRequest.defaults.timeout = 5000;    // 请求超时
httpRequest.defaults.baseURL = '/api/';  // api 即上面 vue.config.js 中配置的地址

Vue.prototype.$http = httpRequest;
Vue.prototype.isAuth = isAuth;     // 权限方法
Vue.prototype.Excel = Excel;    // 导出excel

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
    const role = localStorage.getItem('user');
    if (!role && to.path !== '/login') {
        next('/login');
    } else {
        Vue.prototype.user = JSON.parse(getCookie('user'));
        if (role && to.path === '/login') {
            next('/dashboard');
        }
        // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
        if (navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor') {
            Vue.prototype.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
                confirmButtonText: '确定'
            });
        } else {
            next();
        }
    }
});

new Vue({
    router,
    render: h => h(App)
}).$mount('#app');
